const HeroLeft = () => {
  return (
    <div className="hero-images-wrapper">
      {/* Icons alrededor */}
      <img
        src="assets/images/heroTest/icons.png"
        alt="Icons"
        className="hero-icons"
      />

      {/* Kids centrado */}
      <img
        src="assets/images/heroTest/kids.svg"
        alt="Kids"
        className="hero-kids"
      />
    </div>
  );
};

export default HeroLeft;
